import * as React from 'react';

import { Provider } from './context';

export const withUIStateProvider = (Component: React.ComponentClass) =>
  class WithUIStateProvider extends React.PureComponent {
    public state = {
      error: null,
      setUIState: (value: Record<string, unknown>) => {
        if (!value.hasOwnProperty('set')) {
          this.setState({ ...value });
        }
      },
    };

    public render() {
      return (
        <Provider value={{ ...this.state }}>
          <Component {...this.props} />
        </Provider>
      );
    }
  };
